/**
 * 
 */
class WMUArchive {

	/**
	 * 
	 * @param {*} args 
	 */
	constructor( args = {} )
	{
		this.initArgs = args;
		this.url = args.url || '';
		this.action = args.action || '';
		this.nonce = args.nonce || '';
		this.pageCurrent = args.pageCurrent || 0;
		this.itemsTotal = 0;
		this.itemsPerPage = args.posts_per_page || 10;
		this.items = [];
		this._xhr = null;
		this.queryInProgress = false;

		/**
		 * WP Query parameters
		 */
		this.post_type = args.post_type || 'post';
		this.post_status = args.post_status || 'publish';
		this.order = args.order || 'DESC';
		this.orderby = args.orderby || 'date';
		this.extraQueryArgs = args.extraQueryArgs || {};

		/**
		 * Callbacks
		 */
		this.callback = {
			onNextPage: args.onNextPage || null,
		}
	}

	/**
	 * 
	 */
	get xhr()
	{
		if ( null === this._xhr )
		{
			this._xhr = new XMLHttpRequest();
			
			this._xhr.addEventListener( 'progress', this.onProgress.bind( this ), false );
			this._xhr.addEventListener( 'load', this.onLoad.bind( this ), false );
			this._xhr.addEventListener( 'error', this.onError.bind( this ), false );
			this._xhr.addEventListener( 'abort', this.onAbort.bind( this ), false );
		}

		return this._xhr;
	}

	/**
	 * 
	 */
	get pageTotal()
	{
		return Math.ceil( this.itemsTotal / this.itemsPerPage );
	}

	/**
	 * 
	 */
	hasPageToLoad()
	{
		return ( 0 === this.itemsTotal || this.pageCurrent < this.pageTotal );
	}

	/**
	 * TODO: Faire en sorte de vérifier si on a pas déjà les éléments de la page suivante. Auquel cas on ne fera pas la requête
	 * sauf si on force le reload.
	 */
	nextPage()
	{
		if ( ! this.url || this.queryInProgress || ! this.hasPageToLoad() )
		{
			return false;
		}

		this.pageCurrent++;

		let formData = new FormData();
		let data = {
			action: this.action,
			_ajax_nonce: this.nonce,
			query_args: {
				paged: this.pageCurrent,
				post_type: this.post_type,
				post_status: this.post_status,
				posts_per_page: this.itemsPerPage,
				order: this.order,
				orderby: this.orderby,
				...this.extraQueryArgs
			}
		};

		for ( let key in data )
		{
			if ( 'query_args' === key )
			{
				formData.append( key, JSON.stringify( data[ key ] ) );
			}
			else
			{
				formData.append( key, data[ key ] );
			}
		}

		this.xhr.open( 'POST', this.url );
		this.xhr.send( formData );
		this.queryInProgress = true;
		return true;
	}

	/**
	 * 
	 */
	onProgress( event )
	{
		// console.log( 'WMUArchive.onProgress', event );
	}

	/**
	 * 
	 */
	onLoad( event )
	{
		// console.log( 'WMUArchive.onLoad', event, JSON.parse( this._xhr.response ) );
		let response = null;

		if ( this._xhr.response )
		{
			response = JSON.parse( this._xhr.response );
		}

		// Query success
		if ( response && true === response.success )
		{
			this.itemsTotal = response.data.max_items;

			if ( this.callback.onNextPage )
			{
				this.callback.onNextPage( response.data.items, this );
			}
		}

		// Query error
		else
		{
			console.log( "WMUArchive query error", response, this._xhr );
		}

		this._xhr = null;
		this.queryInProgress = false;
	}

	/**
	 * 
	 */
	onError( event )
	{
		// console.log( 'WMUArchive.onError', event );
		this._xhr = null;
		this.queryInProgress = false;
	}

	/**
	 * 
	 */
	onAbort( event )
	{
		// console.log( 'WMUArchive.onAbort', event );
		this._xhr = null;
		this.queryInProgress = false;
	}

}

export default WMUArchive;